export const MINIGAME_STEPS = {
  NAME_VALIDATOR: 0,
  DATE_VALIDATOR: 1,
  WORDS_MINIGAME: 2,
  OPTION_MINIGAME: 3,
  ODD_ONE_OUT: 4,
  PUZZLE_BOX: 5,
  FINAL_SCREEN: 6,
  COMPLETION: 7,
};

export const TOTAL_STEPS = 8;
